export default {
  SESSION: 'video-session',
};

export const roles = {
  moderator: 'moderator',
  participant: 'participant',
  lobby: 'lobby',
};
